<template>
  <div>
    <div
      v-if="hasStepGuide && step === 4"
      data-testid="btn-back-to-add-fund"
      class="d-flex align-items-center text-placeholder my-2 cursor-pointer"
      @click="$router.push('payment/add-fund?type=recharge')"
    >
      <feather-icon
        icon="ChevronLeftIcon"
        style="margin-right: 8px"
      />
      {{ isSetupCostModel ? $t('billingPage.textBackToSetupCost') : $t('billingPage.textBackToAddFund') }}
    </div>
    <div
      v-if="hasStepGuide && step === 5"
      data-testid="btn-back-to-create-ad-account"
      class="d-flex align-items-center text-placeholder my-2 cursor-pointer"
      @click="$router.push('my-ads-account')"
    >
      <feather-icon
        icon="ChevronLeftIcon"
        style="margin-right: 8px"
      />
      {{ $t('billingPage.textBackToCreateAdAccount') }}
    </div>
    <banner v-if="!isEcomdyPlatform" />
    <!-- <billing-history /> -->

    <div
      :class="[!isEcomdyPlatform ? 'mt-2 mt-md-4' : '']"
      class="tabs-mf bg-white tab-billing "
    >
      <b-tabs data-testid="bottom-box-billing-history">
        <b-tab :active="tab === 'billing_history'">
          <template #title>
            <span
              data-testid="title-billing-history"
              class="tab-title"
            >{{ $t('billingPage.titleBillingHistory') }}</span>
          </template>

          <billing-history />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'

import envMixin from '@/mixins/envMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import Banner from './components/Banner.vue'
import BillingHistory from './components/BillingHistory.vue'

export default {
  components: {
    BillingHistory,
    Banner,
    BTabs,
    BTab,
  },
  mixins: [envMixin, stepGuideMixin, generalConfigsMixin],

  data() {
    return {
      tab: this.$route.query.tab || 'billing_history',
      step: 1,
    }
  },

  watch: {
    user: {
      handler(userInfo) {
        if (userInfo?.data?.onboardingStep) {
          this.step = userInfo?.data?.onboardingStep
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.tab = this.$route.query.tab || 'billing_history'
  },

}
</script>
<style lang="scss" scoped>
.tab-billing {
  border-radius: var(--border-radius-base);
}
</style>

<style lang="scss">
.tab-billing {
  .nav-tabs {
    margin-bottom: 24px;
    padding: 16px 24px 0;
  }
}
</style>
